(() => {
  "use strict";

  // ============================================================
  // PART 1: DROPDOWNS (Sub-menus)
  // ============================================================
  const dropdownWrappers = document.querySelectorAll('li.dropdown');

  const closeAllDropdowns = (currentWrapper = null) => {
    dropdownWrappers.forEach(wrapper => {
      if (wrapper !== currentWrapper) {
        wrapper.classList.remove('open');
        const triggerLink = wrapper.firstElementChild;
        if (triggerLink) triggerLink.setAttribute('aria-expanded', 'false');
      }
    });
  };

  dropdownWrappers.forEach(wrapper => {
    const triggerLink = wrapper.firstElementChild;

    wrapper.addEventListener('click', (e) => {
      // 1. Allow sub-links to work naturally
      if (e.target.closest('.dropdown-nav')) return;

      // 2. Prevent the "Trigger" link from refreshing page
      e.preventDefault();
      
      const isOpen = wrapper.classList.contains('open');
      closeAllDropdowns(wrapper); // Accordion style: close others

      if (!isOpen) {
        wrapper.classList.add('open');
        if (triggerLink) triggerLink.setAttribute('aria-expanded', 'true');
      } else {
        wrapper.classList.remove('open');
        if (triggerLink) triggerLink.setAttribute('aria-expanded', 'false');
      }
    });
  });


  // ============================================================
  // PART 2: MOBILE MENU (The Overlay)
  // ============================================================
  const mobileOpenBtn = document.getElementById('mobileOpen');
  const mobileCloseBtn = document.getElementById('mobileClose');
  const mobileMenuNav = document.getElementById('mobileMenu');
  
  const toggleMobileMenu = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    
    document.body.classList.toggle('mobileMenuOpen');
    mobileMenuNav.classList.toggle('mobileShowing');
    
    // Accessibility State
    const isNowOpen = mobileMenuNav.classList.contains('mobileShowing');
    if (mobileOpenBtn) mobileOpenBtn.setAttribute('aria-expanded', isNowOpen);
  };

  // Attach Toggle Listeners
  if (mobileOpenBtn) mobileOpenBtn.addEventListener('click', toggleMobileMenu);
  if (mobileCloseBtn) mobileCloseBtn.addEventListener('click', toggleMobileMenu);

  // LOGIC: Close Mobile Menu when clicking a Link (Anchors)
  if (mobileMenuNav) {
    mobileMenuNav.addEventListener('click', (e) => {
      const link = e.target.closest('a');
      
      // Ignore if not a link, OR if it was a Dropdown Trigger (prevented by Part 1)
      if (!link || e.defaultPrevented) return;

      // If menu is open, close it so user can see the new page/section
      if (mobileMenuNav.classList.contains('mobileShowing')) {
        toggleMobileMenu(); 
      }
    });
  }


  // ============================================================
  // PART 3: GLOBAL "CLICK OUTSIDE" CLEANUP
  // ============================================================
  window.addEventListener('click', (e) => {
    // 1. Close Dropdowns if clicking outside them
    if (!e.target.closest('li.dropdown')) {
      closeAllDropdowns();
    }

    // Optional: Close Mobile Menu if clicking outside the nav (The Overlay)
    // Only runs if menu is actually open
    if (document.body.classList.contains('mobileMenuOpen')) {
       // If click is NOT on the menu, and NOT on the Open button
       if (!e.target.closest('#mobileMenu') && !e.target.closest('#mobileOpen')) {
         toggleMobileMenu();
       }
    }
  });

})();